/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import ProfileService from '../../../apiServices/ProfileService';
import UserService from '../../../apiServices/UserService';

export const types = {
  REQUEST_PROFILE: 'app/actionItems/REQUEST_PROFILE',
  RECEIVE_PROFILE: 'app/actionItems/RECEIVE_PROFILE',
  RECEIVE_NEW_PROFILE: 'app/actionItems/RECEIVE_NEW_PROFILE',
  REQUEST_USER: 'app/actionItems/REQUEST_USER',
  RECEIVE_USER: 'app/actionItems/RECEIVE_USER',
  RECEIVE_NEW_USER: 'app/actionItems/RECEIVE_NEW_USER',
  UPDATE_PROFILE_ACTION_ITEMS: 'app/actionItems/UPDATE_PROFILE_ACTION_ITEMS',
};

const initialState = {
  existingProfile: null,
  newProfile: null,
  existingUser: null,
  newUser: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.RECEIVE_PROFILE:
    case types.UPDATE_PROFILE_ACTION_ITEMS:
      return _.assign({}, state, {
        existingProfile: _.assign({}, state.existingProfile, {
          [action.profileId]: action.payload,
        }),
      });
    case types.RECEIVE_NEW_PROFILE:
      return _.assign({}, state, {
        newProfile: _.assign({}, action.payload),
      });
    case types.RECEIVE_USER:
      return _.assign({}, state, {
        existingUser: _.assign({}, state.existingUser, {
          [action.userId]: action.payload,
        }),
      });
    case types.RECEIVE_NEW_USER:
      return _.assign({}, state, {
        newUser: _.assign({}, action.payload),
      });
    default:
      return state;
  }
}

function receiveProfileActionItems(profileId, payload) {
  return {
    type: types.RECEIVE_PROFILE,
    profileId,
    payload,
  };
}

function receiveNewProfileActionItems(payload) {
  return {
    type: types.RECEIVE_NEW_PROFILE,
    payload,
  };
}

function receiveUserActionItems(userId, payload) {
  return {
    type: types.RECEIVE_USER,
    userId,
    payload,
  };
}

function receiveNewUserActionItems(payload) {
  return {
    type: types.RECEIVE_NEW_USER,
    payload,
  };
}

function updateProfileActionItems(profileId, payload) {
  return {
    type: types.UPDATE_PROFILE_ACTION_ITEMS,
    profileId,
    payload,
  };
}

// function requestUserActionItems(userId) {
//   return (dispatch) => {
//     return new Promise(async (res) => {
//       const userActionItems = await UserService.getUserActionItems(userId);
//       await dispatch(receiveUserActionItems(userId, userActionItems));
//       res();
//     });
//   };
// }

// function requestProfileActionItems(profileId) {
//   console.log('AAAAA - requestProfileActionItems')
//   return (dispatch) => {
//     return new Promise(async (res) => {
//       const { body: { data: profileActionItems } } = await ProfileService.getProfileActionsItems(profileId);
//       dispatch(receiveProfileActionItems(profileId, profileActionItems));
//       res();
//     });
//   };
// }

// function requestActionItems(userId, profileId) {
//   return (dispatch) => {
//     return new Promise(async (res) => {
//       console.log('BBBBBB - requestActionItems')
//       const { body: { data: profileActionItems } } = await ProfileService.getProfileActionsItems(profileId);
//       dispatch(receiveProfileActionItems(profileId, profileActionItems));

//       if (userId) {
//         const userActionItems = await UserService.getUserActionItems(userId);
//         await dispatch(receiveUserActionItems(userId, userActionItems));
//         res();
//       } else{
//         res();
//       }
//     });
//   };
// }

function requestNewProfileActionItems() {
  return (dispatch) => {
    return new Promise(async (res) => {
      const profileActionItems = await ProfileService.getNewProfileActionItems();
      dispatch(receiveNewProfileActionItems(profileActionItems));
      res();
    });
  };
}

function requestNewUserActionItems() {
  return (dispatch) => {
    return new Promise(async (res) => {
      const userActionItems = await UserService.getNewUserActionItems();
      dispatch(receiveNewUserActionItems(userActionItems));
      res();
    });
  };
}

function clearActionItem(profileId, actionItemName) {
  return (dispatch, getState) => {
    return new Promise(async (res) => {
      const state = getState();
      const profileActionItems = selectors.getProfileActionItems(state, profileId);
      const updatedActionItems = profileActionItems.filter(a => a.view !== actionItemName);

      dispatch(updateProfileActionItems(profileId, updatedActionItems));
      res();
    });
  };
}

export const actions = {
  // requestActionItems,
  requestNewProfileActionItems,
  requestNewUserActionItems,
  clearActionItem,
  // requestUserActionItems,
  // requestProfileActionItems,
  receiveNewProfileActionItems,
  receiveUserActionItems,
  receiveProfileActionItems,
  receiveNewUserActionItems,
};

export const selectors = {
  getProfileActionItems: (state, profileId) => _.get(state, `actionItems.existingProfile.${profileId}.steps`, []),
  hasProfileActionItems: (state, profileId) => _.get(state, `actionItems.existingProfile.${profileId}.steps`, []).length > 0,
  getNewProfileActionItems: (state) => _.get(state, 'actionItems.newProfile.steps', []),
  hasNewProfileActionItems: (state) => _.get(state, 'actionItems.newProfile.steps', []).length > 0,
  getUserActionItems: (state, userId) => _.get(state, `actionItems.existingUser.${userId}.steps`, []),
  hasUserActionItems: (state, userId) => _.get(state, `actionItems.existingUser.${userId}.steps`, []).length > 0,
  getNewUserActionItems: (state) => _.get(state, 'actionItems.newUser.steps', []),
  hasNewUserActionItems: (state) => _.get(state, 'actionItems.newUser.steps', []).length > 0,
  isProfileActionItemsLoaded: (state, profileId) => _.get(state, `actionItems.existingProfile.${profileId}`, null) !== null,
  isUserActionItemsLoaded: (state, userId) => _.get(state, `actionItems.existingUser.${userId}`, null) !== null,
  isNewUserActionItemsLoaded: (state) => _.get(state, 'actionItems.newUser', null) !== null,
};
